import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { CheckSquare, Activity, ShieldCheck, Eye } from 'lucide-react';
export function ReviewProcess() {
  return <FeaturePageLayout hero={{
    badge: 'Step 6 of 7',
    h1: <>
            Review The{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-2258" data-mp="2zr84aqik07of">
              Process
            </span>
          </>,
    subtitle: 'We rigorously test and review the implemented agents, monitoring their interactions to ensure they meet our strict quality standards.'
  }} problem={{
    subtitle: 'The Quality Risk',
    cards: [{
      icon: <Eye className="w-6 h-6 text-teal" data-id="element-2259" data-mp="2gtnqcehbutil" />,
      title: 'Unmonitored Errors',
      desc: 'Deploying AI without a review period can lead to automated mistakes happening at scale.'
    }, {
      icon: <Activity className="w-6 h-6 text-purple" data-id="element-2260" data-mp="1td7qc2xu4m94" />,
      title: 'Performance Drift',
      desc: 'AI agents can sometimes drift from their intended instructions if not properly constrained and monitored.'
    }, {
      icon: <ShieldCheck className="w-6 h-6 text-blue-400" data-id="element-2261" data-mp="224zy25vh5ha0" />,
      title: 'Trust Deficit',
      desc: 'Your human staff needs to trust the AI before they will fully adopt the new automated workflows.'
    }]
  }} solution={{
    badge: 'The Validation',
    title: 'Rigorous Quality Assurance',
    desc: "We don't just set it and forget it. We run the agents in shadow mode and closely monitor their initial live interactions.",
    features: [{
      icon: <Activity className="w-6 h-6 text-teal" data-id="element-2262" data-mp="1ei1mnmm7oziy" />,
      title: 'Live Monitoring',
      desc: 'We track every decision and output the agents make during the initial rollout phase.'
    }, {
      icon: <CheckSquare className="w-6 h-6 text-purple" data-id="element-2263" data-mp="1nhy0rel3m9y6" />,
      title: 'Workflow Validation',
      desc: 'We ensure that the automated tasks are actually saving time and producing the correct business outcomes.'
    }]
  }} data-id="element-2257" data-mp="2utgafqycmbhl" />;
}